var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_ClaimItemType_list_title"),
      pad: "0",
      addBtn: _vm.hasBtn("add-claim-item"),
    },
    on: { new: _vm.toNew },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                showSelect: _vm.showSelect,
                height: _vm.$vuetify.breakpoint.height - 275,
                totalCount: _vm.totalCount,
              },
              on: {
                change: function (page, perpage, callback) {
                  _vm.getList(page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.claim_item_type_name)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          delBtn: _vm.hasBtn("delete-claim-item"),
                          editBtn: _vm.hasBtn("edit-claim-item"),
                          viewBtn: _vm.hasBtn("view-claim-item"),
                          uuid: item.uuid,
                          title: _vm.$t(
                            "label_essweb_ClaimItemType_list_title"
                          ),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toEdit,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }